__turbopack_context__.v({
  "divider": "RelatedEvents-module-scss-module__BNnYdq__divider",
  "dividerContainer": "RelatedEvents-module-scss-module__BNnYdq__dividerContainer",
  "hiddenSeoCopy": "RelatedEvents-module-scss-module__BNnYdq__hiddenSeoCopy",
  "relatedEventsContainer": "RelatedEvents-module-scss-module__BNnYdq__relatedEventsContainer",
  "subtitle": "RelatedEvents-module-scss-module__BNnYdq__subtitle",
  "title": "RelatedEvents-module-scss-module__BNnYdq__title",
});
